import MyModal from "./MyModal";
import "./MyModal.css";
export default MyModal;